import { render, staticRenderFns } from "./WebinarRooms.vue?vue&type=template&id=d80e0e18&"
import script from "./WebinarRooms.vue?vue&type=script&lang=js&"
export * from "./WebinarRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports